export default __webpack_public_path__ + "static/media/eye - inactive_v1.bf8cd37f.svg";